import React from 'react'

export default function IconTextBlock({ color = "", style = {} }) {
    let strokeColor = "#7246B1";
    if (color) strokeColor = color;
    let className = "icons-icon";

    return (
        <svg className={className} style={style} width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.5 10.7279H17.5" stroke={strokeColor} strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M12.5 5.72791H17.5" stroke={strokeColor} strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M2.5 11.5612L5.46083 5.12456C5.49547 5.05545 5.54866 4.99733 5.61445 4.95672C5.68023 4.9161 5.75602 4.89459 5.83333 4.89459C5.91065 4.89459 5.98643 4.9161 6.05222 4.95672C6.118 4.99733 6.17119 5.05545 6.20583 5.12456L9.16667 11.5612" stroke={strokeColor} strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M2.5 15.7279H17.5" stroke={strokeColor} strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M3.26666 9.89459H8.4" stroke={strokeColor} strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
}